'use client';

import { useQuery } from '@tanstack/react-query';
import parse from 'html-react-parser';
import { Clock, CreditCard } from 'lucide-react';
import { Link } from 'shared/lib/i18n';
import { Button } from 'shared/ui/button';
import { getBalance } from '@/enteties/balance/api';
import { balanceKeys } from '@/enteties/balance/api/balance.query-keys';
// eslint-disable-next-line import/no-cycle
import { BalanceSkeleton } from 'widgets/balance-display';
import * as m from '@paraglide/messages';
import { useMemo } from 'react';
import { TooltipWrapper } from '@/shared/ui/tooltips/tooltip-wrapper';
const currency = {
  RUB: '&#8381;',
  USD: '&#36;'
};
export const BalanceDisplay = ({
  menuItem = false,
  closeMenu
}: {
  menuItem?: boolean;
  closeMenu?: () => void;
}) => {
  const {
    data,
    isSuccess
  } = useQuery({
    queryKey: balanceKeys.usersBalance,
    queryFn: () => getBalance()
  });

  // TODO: add IS_INTERNATIONAL to the logic
  const isBalanceChanging = useMemo(() => {
    if (!isSuccess) return false;
    return (data?.delta ?? 0) > 0;
  }, [data?.delta, isSuccess]);
  if (menuItem) return <Button variant="ghost" className="w-full justify-between" onClick={closeMenu} asChild>
        <Link href="/balance" title="Balance Page">
          <div className="flex w-full items-center justify-between">
            <div className="flex">
              <CreditCard className="mr-2 size-4" />
              <span>{m.header_balance()}:</span>
            </div>

            {data?.balance ? <p className="text-body2 font-medium ">
                {data?.balance?.toFixed(2)} {parse(currency[data?.currency])}
              </p> : <BalanceSkeleton />}
          </div>
        </Link>
      </Button>;
  return <div className="flex flex-row items-center gap-2" data-sentry-component="BalanceDisplay" data-sentry-source-file="balance-display.tsx">
      {isBalanceChanging && <TooltipWrapper content={m.balance_tooltip_content()}>
          <Clock className="size-4 text-status-warning" />
        </TooltipWrapper>}
      <Button variant="ghost" size="sm" asChild className="duration-200 active:text-primary-active px-1 sm:px-2" data-sentry-element="Button" data-sentry-source-file="balance-display.tsx">
        <Link href="/balance" title="Balance Page" data-sentry-element="Link" data-sentry-source-file="balance-display.tsx">
          {data?.balance ? <p className="font-medium ">
              {data?.balance?.toFixed(2)} {parse(currency[data?.currency])}
            </p> : <BalanceSkeleton />}
        </Link>
      </Button>
    </div>;
};